<template>
  <el-dialog
    :title="title"
    :visible="is_visible"
    width="560px"
    @close="closeDialog"
  >
    <div v-loading="loading">
      <MultilineInput
        v-if="metaData.panels"
        v-model="UTMList"
        :field="this.metaData.panels[0].rows[0][0]"
        :rules="rules"
        ref="multilineInput"
      />
    </div>
    <div slot="footer">
      <div class="footer" v-if="metaData.buttons_menu">
        <FormButtons
          v-for="item in metaData.buttons_menu[0]"
          :key="item.id"
          :buttons_menu="[[item]]"
          :topPanel="false"
          :loading="loading"
          breakOnSave
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { eventBus } from '@/bus';
import { getController, postController } from '@/controllers/request';
import { Dialog } from 'element-ui';
import { errorMsg } from '@/utils/mixins';
import { MODULE, ACTION, EVENTBUS_EVENTS } from '@/utils/constants';
import MultilineInput from 'Elements/MultilineInput/MultilineInput.vue';
import FormButtons from 'Elements/Form/FormButtons';
export default {
  mixins: [errorMsg],
  data() {
    return {
      title: 'Добавление новых UTM-меток в справочник',
      UTMList: [],
      duplicates: new Set(),
      metaData: {},
      rules: [
        {
          required: true,
          message: 'Заполните поле',
          trigger: 'blur'
        },
        {
          validator: this.checkDuplicates
        }
      ]
    };
  },
  props: {
    is_visible: {
      type: Boolean
    }
  },
  created() {
    this.setLoading(true);
    const params = {
      module: MODULE.HRPAC_UTM,
      action: ACTION.GET_NEW_UTM_POPUP,
      to_pdf: true
    };

    getController({ params }).then(res => {
      this.metaData = res.data.metadata;
      this.setLoading(false);
    });

    eventBus.$on(EVENTBUS_EVENTS.SAVEFORM, this.saveForm);
    eventBus.$on(EVENTBUS_EVENTS.CLOSE_POPUP, this.closeDialog);
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.SAVEFORM);
    eventBus.$off(EVENTBUS_EVENTS.CLOSE_POPUP);
  },
  methods: {
    checkDuplicates(rule, value, callback) {
      if (this.duplicates.has(value)) {
        callback('Есть метка с таким значением');
      } else {
        callback();
      }
    },
    async saveForm(intents) {
      if (!this.UTMList.length) {
        this.closeDialog()
        return;
      };

      const multilineInput = this.$refs['multilineInput'];
      const isValid = await multilineInput.isValid();
      if (!isValid) return

      this.setLoading(true);
      const { url, request_params } = intents[0].request;

      const formData = new FormData();
      Object.entries(request_params).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const newUTMList = this.UTMList.map(({ value }) => value);
      newUTMList.forEach(value => {
        formData.append('new_utm[]', value);
      });

      postController({ url, options: formData }).then(res => {
        this.setLoading(false);
        const { status, message, error, data } = res.data;
        if (status == 'success') {
          if (message) {
            this.showNotification({
              message: res.data.message,
              type: 'success',
              showClose: false
            });
          }
          this.closeDialog();
        } else if (status == 'error') {

          if (data) {
            data.forEach((utm) => {
              this.duplicates.add(utm)
            });
            multilineInput.isValid();
          }
          
          if (error?.error_text) {
            this.showNotification({
              message: error.error_text.error,
              type: 'error',
              showClose: false
            });
          }
        }
      });
    },
    closeDialog() {
      store.commit('common/setVisibleDialog', {
        name: 'publicator_utm_creation_dialog',
        val: false
      });
    },
    setLoading(value) {
      store.commit('dialog/setLoading', value);
    }
  },
  computed: {
    loading() {
      return store.state.dialog.loading;
    }
  },
  components: {
    'el-dialog': Dialog,
    MultilineInput,
    FormButtons
  }
};
</script>
<style lang="scss" scoped></style>
